import { getItem, removeItem, setItem } from '../../../utils/localStorage';
import {
  IFeatureFlagResponse,
  ILearningGameFlag,
  IUserContext,
} from '../interfaces/featureFlags';

const setFeatureFlags = (featureFlags: IFeatureFlagResponse) => {
  if (featureFlags.flags) {
    setItem('featureFlags', featureFlags.flags);
  }
};

const setUserContext = (userContext: IUserContext) => {
  if (userContext) {
    setItem('userContext', userContext);
  }
};

const getFeatureFlags = () => {
  return getItem('featureFlags');
};

const getFeatureFlagByKey = (
  featureFlagKey: string
): boolean | ILearningGameFlag | undefined => {
  const featureFlags = getFeatureFlags();
  if (!featureFlags) {
    return undefined;
  }
  return featureFlags[featureFlagKey];
};

const getUserContext = () => {
  return getItem('userContext');
};

const clearFeatureFlagsAndUserContext = () => {
  removeItem('featureFlags');
  removeItem('userContext');
};

export const featureFlagsHelpers = {
  setFeatureFlags,
  setUserContext,
  getFeatureFlags,
  getFeatureFlagByKey,
  getUserContext,
  clearFeatureFlagsAndUserContext,
};
